export const PleaseRelogin = () => (
  <div className="alert alert-danger alert-dismissible fade show">
    <strong>Please relogin.</strong>
  </div>
);
